import type { QueryClient } from '@tanstack/react-query'

import { getAccountId } from '~/helpers'

export const advertiserBrandsQueryKey = 'get-advertiser-brands'
export const advertiserBrandProductsQueryKey = 'get-advertiser-brand-products'
export const advertiserBrandSuggestionsQueryKey =
  'get-advertiser-brand-suggestions'
export const advertiserBrandCatalogSearchQueryKey =
  'post-advertiser-brand-catalog-search'
export const advertiserBrandCatalogNameSearchQueryKey =
  'post-advertiser-brand-catalog-name-search'
export const advertiserBrandCatalogBatchQueryKey =
  'post-advertiser-brand-catalog-batch'

/** Chave por conta: o `queryClient` sobrevive à troca de conta. */
export const advertiserBrandKey = (key: string, ...rest: unknown[]) => [
  key,
  getAccountId(),
  ...rest
]

/**
 * Teto das leituras sem paginação (marcas para select, produtos para marcar
 * "já adicionado"): acima disso a marcação de existente deixa de ser completa.
 */
export const ADVERTISER_BRAND_LIST_LIMIT = 500

/**
 * Toda escrita mexe nas três listas: a contagem por marca vem do mesmo agregado
 * das marcas, e as sugestões são de produtos sem vínculo.
 */
export const invalidateAdvertiserBrandQueries = (queryClient: QueryClient) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: advertiserBrandKey(advertiserBrandsQueryKey)
    }),
    queryClient.invalidateQueries({
      queryKey: advertiserBrandKey(advertiserBrandProductsQueryKey)
    }),
    queryClient.invalidateQueries({
      queryKey: advertiserBrandKey(advertiserBrandSuggestionsQueryKey)
    })
  ])
